import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import { i18nPromise } from './config/i18n/i18n';

const container = document.getElementById('root')!;
const root = createRoot(container);

// Attendi il completamento dell'inizializzazione di i18next
i18nPromise.then(() => {
  // Solo dopo che i18n è pronto, renderizza l'applicazione
  root.render(<App />);
});